import { GET_DEPARTMENT_FORM_SUCCESS, SET_FILTER_LIST } from "../../common/actionTypes";
import { getEnv } from "../../enviroment";
import { fetch_retry_get, fetch_retry_post } from "./ApiManager";
const { base } = getEnv();
const getFilterList = (client) => async (dispatch) => {
  try {
    let response = await fetch_retry_get(`${base}/auto-provisioning/filters/get/${client}`);
    let resp = await response;
    if (resp && (resp.status === 200 || resp.status === 201)) {
      dispatch({
        type: SET_FILTER_LIST,
        payload: resp.data,
      });
      return { success: true, data: resp };
    } else {
      return { success: false, message: resp.data.message };
    }
  } catch (error) {
    console.error("error", error);
    return { success: false, message: error.data };
  }
};
export const AutoProvisioning = {
    getFilterList
};
